<app-crud-table #ccCrudTable [crudService]="crudService"
                [transPartKey]="'user-view'" [fieldId]="'id'" [fieldName]="'viewName'" [fieldEnabled]="'visible'"
                [defaultSortOrder]="1" [defaultSortField]="'sortOrder'"
                [tableConfig]="tableConfig" [newRecord]="newRecord"
                [(formRecord)]="formRecord" [formConfig]="formConfig"
                [formLoading]="formLoading" [(tableCurrentRequest)]="tableCurrentRequest"
                [(records)]="records"
                [settingsFormLoadingProgressValue]="settingsFormLoadingProgressValue" [tableLoading]="tableLoading"
                [prepareForCreate]="prepareRecordForCreate"
                [prepareForClone]="prepareRecordForClone"
                [prepareForEdit]="prepareForEdit"
                [beforeSave]="beforeSave"
                [reorderableRows]="true" (rowOrderChanged)="rowOrderChanged($event)" [totalRecords]="totalRecords"
                [lazyLoadOnInit]="true" [dialogClass]="'user-view-form-dialog'"
                (dialogFormVisibleChange)="onFormVisibilityChange($event)" (onSave)="saveComplete()"
                [disableFilters]="true"
                (tableCurrentRequestChange)="tableCurrentRequestChanged()"
>
        <span table-toolbar-left>
          <p-dropdown *ngIf="users.length>0" [options]="users" [(ngModel)]="selectedUser" optionLabel="text" [optionValue]="'id'" class="user-name-menu"
                         (onChange)="userChanged($event)" [filter]="true"></p-dropdown>

        </span>
</app-crud-table>
